"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectionMoveBinding = selectionMoveBinding;
var model_1 = require("../../model");
var draw_state_1 = require("../draw.state");
var label_draw_svg_1 = require("../drawable/label.draw.svg");
var util_draw_svg_1 = require("../drawable/util.draw.svg");
var util_1 = require("../util");
function selectionMoveBinding(dc, evt) {
    var delta = evt.delta;
    if (evt.label === 'image') {
        var centerX = dc.state.centerX;
        var centerY = dc.state.centerY;
        var newPoint = (0, util_1.movePoint)({ x: centerX, y: centerY }, 
        // Moving images is in the opposite direction of the mouse movements
        { x: -delta.x, y: -delta.y }, dc.capture.resolution);
        dc.state.setCenter(newPoint.x, newPoint.y);
        return;
    }
    var currentId = dc.state.selectedId;
    if (currentId == null) {
        return;
    }
    if (evt.$event) {
        evt.$event.preventDefault();
    }
    // If we have the base tool selected, we cannot move any drawables
    if (dc.state.tool === draw_state_1.IkeDrawTool.BASE) {
        return;
    }
    var drawableToMove = dc.selected;
    if (evt.label === util_draw_svg_1.IkeDrawLabel.LABEL) {
        if (model_1.CollectionModelDrawableMarker.isMarker(drawableToMove) ||
            model_1.CollectionModelDrawableLine.isLine(drawableToMove)) {
            return moveLabel(dc, drawableToMove, delta);
        }
    }
    // Dragging a point in the line references the point rather than the line element its self. so we need to target the parent instead
    if (model_1.CollectionModelDrawableLinePoint.isLinePoint(drawableToMove)) {
        drawableToMove = drawableToMove.parent;
    }
    // Remove insight flags from the drawable, and the base / base offset
    // This should not trigger as we don't support insight base & base offsets made by the back end yet
    drawableToMove.approveInsightFlag();
    if (dc.drawState.insightBase) {
        dc.drawState.insightBase.approveInsightFlag();
    }
    if (dc.drawState.insightBaseOffset) {
        dc.drawState.insightBaseOffset.approveInsightFlag();
    }
    if (model_1.CollectionModelDrawableLine.isLine(drawableToMove)) {
        if (evt.label === util_draw_svg_1.IkeDrawLabel.START || evt.label === null) {
            drawableToMove = drawableToMove.start;
        }
        else if (evt.label === util_draw_svg_1.IkeDrawLabel.END) {
            drawableToMove = drawableToMove.end;
        }
    }
    var moveTo = (0, util_1.movePoint)(drawableToMove.state, delta, dc.capture.resolution);
    return drawableToMove.Mutator.move(moveTo.x, moveTo.y);
}
function moveLabel(dc, drawable, delta) {
    var label = drawable.label;
    var uiScale = dc.state.scale;
    var moveTo = (0, util_1.movePoint)(label.state, delta, dc.capture.resolution, {
        width: label_draw_svg_1.LabelSVGDraw.Size.width * uiScale,
        height: label_draw_svg_1.LabelSVGDraw.height(1) * uiScale
    });
    label.Mutator.move(moveTo.x, moveTo.y);
}
//# sourceMappingURL=selection.move.binding.js.map